/** Read auth payload cached by login / refresh (Phase 5). */

export function getUserData() {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (e) {
    return {};
  }
}

/** Tenant or platform admins who can edit organization branding. */
export function canManageOrganization() {
  const d = getUserData();
  const roles = Array.isArray(d.roles) ? d.roles : [];
  const isPlatformAdmin = roles.some((r) => r === 'ROLE_ADMIN');
  const tr = d.tenantRole;
  return isPlatformAdmin || tr === 'tenant_admin' || tr === 'super_admin';
}

export function getTenantRole() {
  return getUserData().tenantRole || null;
}
